import { Component, OnInit ,Output,EventEmitter,Input} from '@angular/core';

@Component({
    selector: 'app-default-redirection-screen',
    templateUrl: './default-redirection-screen.component.html',
    styleUrls: ['./default-redirection-screen.component.scss'],
    standalone: false
})
export class DefaultRedirectionScreenComponent implements OnInit {

  @Output() emitLogoutEvent = new EventEmitter();
  @Output() emitCancelEvent = new EventEmitter();
  @Output() emitOkayEvent = new EventEmitter();
  @Input() heading_message = '';
  @Input() paragraph_message = '';
  @Input() is_signed_differen_user=false;
  @Input() has_cancelled = false;

  constructor() { }

  ngOnInit(): void {
  } 


  logoutHandler(){  this.emitLogoutEvent.emit('logout'); }

  cancelHandler() { this.emitCancelEvent.emit('cancel'); }


  okayHandler() { this.emitOkayEvent.emit('okay'); }

}
